import { createContext, ReactNode, useContext, useEffect } from "react";
import { handleError } from "../../utils/handleError";
import useStore from "../common/useStore";
import ConvertionRatesStore from "./ConvertionRatesStore";

const ConvertionRatesStoreContext = createContext<ConvertionRatesStore | null>(
  null
);

export const ConvertionRatesStoreProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const store = useStore(ConvertionRatesStore, []);
  const { fetchRates } = store;

  useEffect(() => {
    const load = async () => {
      try {
        await store.fetchRates();
      } catch (error) {
        handleError(error, "useConvertionRatesStore. useEffect.");
      }
    };
    load();

    return () => {
      store.cancel();
    };
  }, [fetchRates]);

  return (
    <ConvertionRatesStoreContext.Provider value={store}>
      {children}
    </ConvertionRatesStoreContext.Provider>
  );
};

export const useConvertionRatesStore = () => {
  const store = useContext(ConvertionRatesStoreContext);

  if (!store) {
    throw new Error(
      "useConvertionRatesStore should be called inside ConvertionRatesStoreProvider"
    );
  }

  return store;
};
